import React, { useMemo } from 'react';
import ModalFormPro from '@/components/ModalFormPro';

const UpdateForm = (props) => {
  const { visible, onCancel, onOk, initialValues, postList } = props;

  // Map postList to standard options format { label, value }
  const postOptions = useMemo(() => {
    return (
      postList?.map((item) => ({
        label: item.value || item.postName,
        value: item.id,
      })) || []
    );
  }, [postList]);

  const edtaFormItem = useMemo(
    () => [
      {
        label: '标签名称',
        name: 'tagName',
        type: 'Input',
        required: '请输入标签名称',
        props: {
          placeholder: '请输入标签名称',
        },
      },
      {
        label: '标签描述',
        name: 'tagDesc',
        type: 'TextArea',
        props: {
          placeholder: '请输入标签描述',
          rows: 4,
        },
      },
      {
        label: '关联岗位',
        name: 'postList',
        type: 'Select',
        required: '请选择关联岗位',
        props: {
          mode: 'multiple',
          placeholder: '请选择岗位',
          options: postOptions,
          allowClear: true,
          filterOption: (input, option) =>
            (option?.label ?? '').toLowerCase().includes(input.toLowerCase()),
        },
      },
      {
        label: '排序',
        name: 'tagSort',
        type: 'InputNumber',
        props: {
          placeholder: '请输入排序',
          stepType: 'inside',
        },
      },
    ],
    [postOptions],
  );

  const formData = useMemo(() => {
    if (!initialValues) return {};
    return {
      ...initialValues,
      postList: initialValues.postList?.map((item) => item.id) || [],
    };
  }, [initialValues]);

  return (
    <ModalFormPro
      visible={visible}
      onCancel={onCancel}
      onSave={onOk}
      formData={formData}
      edtaFormItem={edtaFormItem}
      width={600}
      title={initialValues ? '修改标签' : '新增标签'}
    />
  );
};

export default UpdateForm;
